import React, { Component } from 'react'
import './index.css'
import { BsyUtils } from "../../utils/Utils";
import LoginAccountInput from "../../Login/LoginAccountInput";
import BsyIconBtn from "../BsyIconBtn";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../BsyAlert";
import BsyDialog from '../BsyDialog';
import BsyAlertMenu from "../BsyAlertMenu";
import BsyDeptJobtitleSelectPane from '../BsyDeptJobtitleSelectPane';
import BsyCreateRelationPane from '../BsyCreateRelationPane';

import BsySelect from '../BsySelect';
import { dayjsUtils } from '../../utils/dayjsUtils';

class AlertList extends Component {
    constructor(props) {
        super(props);
        let relationMap = {};
        props.relation_list && props.relation_list.map((res => (
            relationMap[res._id] = res
        )))
        this.state = {
            relation_status: props.relation_status,
            relation_list: props.relation_list,
            relationMap: relationMap,
            relations: props.relations,
            remark: props.remark,
            _id: props._id,
            sort: props.sort,
            username: props.username,
            title: props.title,
            nickname: props.nickname,
            userUniqueId: props.uniqueid,
            memberStatus: props.memberStatus,
            memberType: props.memberType,
            groupname: props.groupname,
            phone: props.phone,
            email: props.email,
            main_deptId: props.main_deptId,
            departments: props.departments,
            roles: props.roles,
            jobs: props.jobs,
            country_code: props.country_code,
            emailstatus: props.emailstatus,
            mobilestatus: props.mobilestatus,
            job_title: props.job_title,
            roleSync: props.roleSync,
            memberRemove: props.memberRemove,
            verifyBtn: true,
            selectRelationOpen: !1,
        }
        if (props.memberType !== 'outsider') {
            if (props.departments) {
                this.orgDeparts = props.departments.map((item, index) => {
                    //selectMap
                    return item.id || item._id;
                })
            }
            if (props.roles) {
                this.orgRoles = props.roles.map((item, index) => {
                    //selectMap
                    return item.id || item._id;
                })
            }
        }
    }

    _getCategory = (category) => {
        var str = "";
        switch (category) {
            case 0:
                str = React.language("manager.creator");
                break;
            case 1:
                str = React.language("manager");
                break;
            case 2:
                str = React.language("member");
                break;
            case -1:
                str = React.language("Invited");
                break;
            case 6:
                str = React.language("unactivated");
                break;
            default:
                str = React.language("member");
        }
        return str;
    }

    dismissionClick = () => {
        const { _id } = this.state;
        const { onReList } = this.props;
        BsyAlert({
            title: React.language("dismission.alert.tip"),
            msg: React.language("dismission.alert.tip1"),
            type: "query",
            text4Ok: React.language("confirm"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
                React.axios('/corp/member/dismission', {
                    members: [_id]
                }).then(res => {
                    onReList && onReList()
                }).catch(res => {

                })
            }
        })
    }


    remarkChange = (event) => {
        const { remark } = this.state;
        if (event.target.value !== remark) {
            this.setState({ remark: event.target.value })
        }
    }
    nicknameChange = (event) => {
        const { nickname } = this.state;
        if (event.target.value !== nickname) {
            this.setState({ nickname: event.target.value })
        }
    }
    titleChange = (event) => {
        const { title } = this.state;
        if (event.target.value !== title) {
            this.setState({ title: event.target.value })
        }
    }
    userUniqueIdChange = (event) => {
        const { userUniqueId } = this.state;
        if (event.target.value !== userUniqueId) {
            this.setState({ userUniqueId: event.target.value })
        }
    }
    sortChange = (event) => {
        const { sort } = this.state;
        if (event.target.value !== sort) {
            this.setState({ sort: event.target.value })
        }
    }
    cancelClick = () => {
        this.props.onRemoveRoot();
        // document.getElementsByClassName("BsyAlertListDetail")[0].remove()
    }
    onSave = () => {
        const { remark, _id, title, nickname, userUniqueId, sort, memberStatus, departments, roles, main_deptId, relations } = this.state;
        const { onReList, mobileCodeLogin, emailCodeLogin, uid } = this.props;
        const { orgDeparts, orgRoles } = this;
        let countryCode = this.getPhone ? this.getPhone.state.countryCode : "+86";
        let phone = this.getPhone ? this.getPhone.state.value : null;
        let email = this.getEmail ? this.getEmail.state.value : null;
        let requiredTip = '';
        let flag = true;

        if (BsyUtils.isCommon()) {

            if (this.getPhone && this.getEmail) {

                if ((emailCodeLogin && mobileCodeLogin) || (!emailCodeLogin && !mobileCodeLogin)) {
                    requiredTip = React.language('invite.phone.and.email.required')
                } else if (!emailCodeLogin && mobileCodeLogin) {
                    requiredTip = React.language('invite.phone.required')
                } else if (emailCodeLogin && !mobileCodeLogin) {
                    requiredTip = React.language('invite.email.required')
                }

                if ((emailCodeLogin && mobileCodeLogin) || (!emailCodeLogin && !mobileCodeLogin)) {
                    if (!email && !phone) {
                        this.setState({ emailError: true, phoneError: true }, () => {
                            tipAlert({
                                type: 'warning',
                                msg: requiredTip
                            })
                        })
                        flag = false;
                    }
                } else {
                    if (!phone && mobileCodeLogin) {
                        this.setState({ phoneError: true }, () => {
                            tipAlert({
                                type: 'warning',
                                msg: requiredTip
                            })
                        })
                        flag = false;
                    }
                    if (!email && emailCodeLogin) {
                        this.setState({ emailError: true }, () => {
                            tipAlert({
                                type: 'warning',
                                msg: requiredTip
                            })
                        })
                        flag = false;
                    }
                }
            }
        }



        if (!flag) {
            return
        }


        if (this.props.onSave) {
            this.props.onSave({
                remark,
                sort,
                nickname,
                userUniqueId,
                group_id: memberStatus,
                phone,
                country_code: countryCode,
                email
            })
        } else {
            let remove = [];
            let add = [];

            let Rremove = [];
            let Radd = [];
            if (this.getPhone && this.getEmail) {
                let departs = departments.map((item, index) => {
                    //selectMap
                    return item.id || item._id;
                })

                let rls = roles.map((item, index) => {
                    //selectMap
                    return item.id || item._id;
                })



                departs.map((item, index) => {

                    if (orgDeparts.indexOf(item) === -1) {
                        add.push(item);
                    }

                    return item.id;
                })

                rls.map((item, index) => {

                    if (orgRoles.indexOf(item) === -1) {
                        Radd.push(item);
                    }

                    return item.id;
                })

                orgDeparts.map((item, index) => {

                    if (departs.indexOf(item) === -1) {
                        remove.push(item);
                    }

                    return item.id;
                })

                orgRoles.map((item, index) => {

                    if (rls.indexOf(item) === -1) {
                        Rremove.push(item);
                    }

                    return item.id;
                })


                this.orgDeparts = departs;
                this.orgRoles = rls;
            }

            let newRelations = [];
            let hasErrorRelation = false;
            relations.map(res => {
                if (!!res.r_id && !!res._id && !!res.bind_userid && !!res.bind_uid && !!res.username) {
                    newRelations.push(res);
                } else {
                    hasErrorRelation = true;
                }
            })

            if (hasErrorRelation) {
                tipAlert({
                    type: "warning",
                    msg: React.language('relation.save.user.tip')
                })
                return
            }

            React.axios("/corp/member/setuserfield", {
                remark: remark,
                _id: _id,
                title: title,
                main_deptId: main_deptId,
                job_title: this.job_title,
                sort: sort,
                nickname: nickname,
                userUniqueId: userUniqueId,
                country_code: countryCode,
                phone,
                email,
                departmentId: {
                    add: add,
                    remove: remove
                },
                role: {
                    add: Radd,
                    remove: Rremove
                },
                uid: uid,
                relations: newRelations,
            }).then(res => {
                tipAlert({
                    type: "success",
                    msg: React.language("saveInfo.success")
                })
                onReList && onReList();
                this.props.onRemoveRoot && this.props.onRemoveRoot();
            }).catch(res => {

            })
        }

    }


    _createChangOutsiderBubble = (b) => {

        let that = this;
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 586,
            width: 956,
            contentWidget: {
                rowSize: [450],
                colSize: [926],
                padding: 15,
                items: [[{
                    hasDock: false,
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    radioEnable: !0,
                    checkEnable: !1,
                    memberEnable: !1,
                    departmentEnable: !1,
                    outsiderMemberEnable: !1,
                    // outsiderGroupEnable:!1,
                    roleEnable: !1,
                    dynamicEnable: !1,
                    dynamicType: "set",
                    jsonValue: {
                        users: [],
                        outsiderGroup: b ? [b] : []
                    }
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                if (d1.outsiderGroup.length === 0) {
                    return
                }

                that.setState({
                    groupname: dept.selectMap[d1.outsiderGroup[0]].name,
                    memberStatus: d1.outsiderGroup[0],
                })
                return !1;
            }
        });
        d.show()
    }

    verifyEmailMobile = (type, event) => {
        event.stopPropagation();
        const { verifyBtn, _id } = this.state;
        if (verifyBtn) {
            this.setState({ verifyBtn: false }, function () {
                React.axios('/corp/member/validate', {
                    mode: type,
                    memberIds: [_id]
                }).then(res => {
                    this.setState({ verifyBtn: true })
                    tipAlert({
                        type: res.data.success == 1 ? "success" : "error",
                        msg: res.data.info
                    })

                }).catch(res => {
                    this.setState({ verifyBtn: true })
                })
            })

        }
    }

    onlyReadPane = () => {

        const { email, nickname, phone, _id, category, mode, leave_time } = this.props;
        const { memberStatus, memberType, groupname, userUniqueId, departments, roleSync, roles, jobs, emailstatus, country_code, mobilestatus } = this.state;

        if (memberType !== 'outsider') {
            return <div className="notEdit">
                <div className="editTitle">
                    {React.language('Non-editable.details')}
                </div>
                <div className="detailCont">
                    {mode === "resign" && <div className="name line">
                        <span className="detailTitle">{React.language('name') + "："}</span>
                        <span className="detailText">{nickname}</span>
                    </div>}
                    {mode !== "resign" && <div className="phone line">
                        <span className="detailTitle">{React.language('widget.phone') + "："}</span>
                        {phone && <span className="detailText">{(country_code ? ('+' + country_code) : '') + phone}</span>}
                        {phone && mobilestatus === 0 && <div className="detailStatus">
                            <span className="statusTip">{React.language('msg.target.phone.unverified')}</span>
                            <span className="sendVer" onClick={e => this.verifyEmailMobile("mobile", e)}>{React.language('click.ver')}</span>
                        </div>}
                    </div>}
                    {mode !== "resign" && <div className="email line">
                        <span className="detailTitle">{React.language('email') + "："}</span>
                        <span className="detailText">{email + ((email && emailstatus == 0) ? " (" + React.language('filter.method.nvf') + ")" : '')}</span>
                        {email && emailstatus === 0 && <div className="detailStatus">
                            <span className="statusTip">{React.language('msg.target.email.unverified')}</span>
                            <span className="sendVer" onClick={e => this.verifyEmailMobile("email", e)}>{React.language('click.ver')}</span>
                        </div>}
                    </div>}
                    <div className="uid line">
                        <span className="detailTitle">{"userId："}</span>
                        <span className="detailText">{_id}</span>
                    </div>
                    <div className="state line">
                        <span className="detailTitle">{React.language('state') + "："}</span>
                        <span className="detailText">{this._getCategory(category)}</span>
                    </div>
                    {mode === "resign" && <div className="time line">
                        <span className="detailTitle">{React.language('resign.time') + "："}</span>
                        <span className="detailText">{BsyUtils.date2Str(dayjsUtils.timeToTZ(leave_time), "yyyy-MM-dd HH:mm:ss")}</span>
                    </div>}
                    {
                        !BsyUtils.isCommon() ? mode !== "resign" && <div className="userUniqueId line">
                            <span className="detailTitle">{React.language('enterprise.user.id')}</span>
                            <span className="detailText">{userUniqueId}</span>

                        </div> : ''
                    }
                    {
                        !BsyUtils.isCommon() ? mode !== "resign" && <div className="name line">
                            <span className="detailTitle">{React.language('name')}</span>
                            <span className="detailText">{nickname}</span>
                        </div> : ''
                    }

                    {
                        !BsyUtils.isCommon() ? mode !== "resign" && <div className="name line">
                            <span className="detailTitle ">{React.language('department')}</span>
                            <div className='detailText departmentCont' >
                                {
                                    departments.length === 0 ? <div className="select-empty"><span>{React.language('widget.dept.clickToSelect')}</span></div> :
                                        departments.map((item, index) => {
                                            return <div className="item-content department"><i className="icon-department"  ></i><span>{item.nickname || item.name}</span></div>
                                        })
                                }
                            </div>
                        </div> : ''
                    }

                    {
                        !BsyUtils.isCommon() && roleSync ? <div className="name line">

                            <span className="detailTitle ">{React.language('role')}</span>
                            <div className='departmentCont'  >
                                {
                                    roles.length === 0 ? <div className="select-empty"><span>{React.language('role.select.tip')}</span></div> :
                                        roles.map(item => {
                                            return <div className="item-content role"><i className="icon-role" /><span>{item.nickname || item.name}</span></div>
                                        })
                                }
                            </div>
                        </div> : ''
                    }


                </div>
            </div>
        } else {
            if (memberStatus === 'deleted') {
                return <div className="notEdit">
                    <div className="editTitle">
                        {React.language('Non-editable.details')}
                    </div>
                    <div className="detailCont">

                        <div className="name line">
                            <span className="detailTitle">{React.language('name')}</span>
                            <span className="detailText">{nickname}</span>
                        </div>

                        <div className="name line">
                            <span className="detailTitle">{React.language('group')}</span>
                            <span className="detailText">{groupname}</span>
                        </div>
                    </div>
                </div>

            }
            return <div className="notEdit">
                <div className="editTitle">
                    {React.language('Non-editable.details')}
                </div>
                <div className="detailCont">
                    <div className="phone line">
                        <span className="detailTitle">{React.language('widget.phone') + "："}</span>
                        {phone && <span className="detailText">{(country_code ? ('+' + country_code) : '') + phone}</span>}
                    </div>
                    <div className="email line">
                        <span className="detailTitle">{React.language('email') + "："}</span>
                        <span className="detailText">{email + ((email && emailstatus == 0) ? " (" + React.language('filter.method.nvf') + ")" : '')}</span>
                    </div>
                    <div className="uid line">
                        <span className="detailTitle">{"userId："}</span>
                        <span className="detailText">{_id}</span>
                    </div>
                    <div className="state line">
                        <span className="detailTitle">{React.language('state') + "："}</span>
                        <span className="detailText">{this._getCategory(category)}</span>
                    </div>
                </div>
            </div>
        }
    }

    _createChangeRoleBubble = (b) => {
        let that = this;
        const { roles, roleSync } = this.state;
        if (!BsyUtils.isCommon() && roleSync) {
            return
        }
        const rls = roles.map((item, index) => {
            return item._id
        })
        b.target.classList.add("select")
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 586,
            width: 956,
            contentWidget: {
                rowSize: [450],
                colSize: [926],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    memberEnable: !1,
                    departmentEnable: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    roleEnable: !0,
                    roleChildEnable: !0,
                    dynamicEnable: !1,
                    dynamicType: "set",
                    value: rls,
                    hasDock: false,
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                if (d1.roles.length === 0) {
                    that.setState({
                        roles: []
                    })
                    return !1;
                }
                const role = d1.roles.map((item, index) => {
                    return {
                        id: dept.selectMap[item].role_id,
                        name: dept.selectMap[item].name,
                        _id: item,
                    }
                })
                that.setState({
                    roles: role
                })
                b.target.classList.remove("select")
                return !1;
            },
            onClose: function () {
                b.target.classList.remove("select")
            }
        });
        d.show()
    }

    _createChangeDepartmentBubble = (b) => {
        const { departments, main_deptId } = this.state;
        let that = this;
        const value = departments.map((item, index) => {
            return item._id
        })
        b.target.classList.add("select")
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 586,
            width: 956,
            contentWidget: {
                rowSize: [450],
                colSize: [926],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    memberEnable: !1,
                    departmentEnable: !0,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    roleEnable: !1,
                    dynamicEnable: !1,
                    dynamicType: "set",
                    value: value,
                    hasDock: false,
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                let deptListId = [];
                let hasMainDept = false;
                if (!d1) {
                    return;
                }

                if (d1.departs.length === 0) {
                    tipAlert({
                        type: 'warning',
                        msg: React.language('dept.entry.tip1')
                    })
                    return
                }
                const departments2 = d1.departs.map((item, index) => {
                    if (main_deptId === dept.selectMap[item].departmentId) {
                        hasMainDept = true
                    }
                    deptListId.push(dept.selectMap[item].departmentId);
                    return {
                        id: dept.selectMap[item].departmentId,
                        _id: dept.selectMap[item].id,
                        nickname: dept.selectMap[item].name
                    }
                })
                if (!hasMainDept) {
                    that.setState({
                        departments: departments2,
                        main_deptId: Math.max(...deptListId),
                    })
                } else {
                    that.setState({
                        departments: departments2
                    })
                }
                b.target.classList.remove("select")
                return !1;
            },
            onClose: function () {
                b.target.classList.remove("select")
            }
        });
        d.show()
    }

    _createChangeJobTitleBubble = (b) => {
        const { jobs, departments } = this.state;
        this.jobs = jobs;
        BsyDialog({
            title: React.language("address.book.dept.set.title"),
            height: 577,
            width: 956,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onOk: () => {
              
            },
            onContentCreate: () => {
                return <BsyDeptJobtitleSelectPane
                    jobtitles={jobs}
                    departments={departments}
                    onStopEdit={(numberValue, _idValue) => {
                        this.jobs = _idValue;
                        this.job_title = numberValue
                    }}
                >
                </BsyDeptJobtitleSelectPane>
            },
            onOk: () => {
                this.setState({
                    jobs: this.jobs,
                    job_title: this.job_title,
                })
            }
        })

    }

    phoneValue = (rel) => {
        this.getPhone = rel
    }

    changePhone = (event) => {
        const { value } = event.target
        this.setState({
            phone: value,
            phoneError: false
        })
    }

    emailValue = (rel) => {
        this.getEmail = rel
    }

    changeEmail = (event) => {
        const { value } = event.target
        this.setState({
            email: value,
            emailError: false
        })
    }

    switchRelation = (item) => {
        return (event) => {
            event && event.stopPropagation();
            event && event.preventDefault();
            const { relation_list, relations } = this.state;
            const menu = relation_list.map(res => {
                return {
                    text: res.name,
                    selected: item.r_id === res._id,
                    extIcon: item.r_id === res._id ? "icon-ok" : "",
                    extIconColor: "#0265ff",
                    click: () => {
                        relations.map(res1 => {
                            if (res1._id === item._id) {
                                res1.r_id = res._id
                            }
                        })
                        this.setState({ relations })
                    }
                }
            })
            menu.push({
                text: React.language('create'),
                textColor: "#0265ff",
                click: () => {
                    this.openCreateRelation()
                }
            })
            const e = event.currentTarget
            e.children[1].classList.add("selectRelationOpen");
            BsyAlertMenu({
                item: menu,
                width: 140,
                target: e,
                onClose: () => {
                    e.children[1].classList.remove("selectRelationOpen");
                    return !0
                }
            })

        }
    }

    deepCopy = (obj, visited = new WeakMap()) => {
        // 如果 obj 是 null 或不是对象，直接返回它自身
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }

        // 如果 obj 已经被访问过，返回它的副本以避免循环引用
        if (visited.has(obj)) {
            return visited.get(obj);
        }

        // 根据 obj 的类型创建一个新的空对象或数组
        let copy;
        if (Array.isArray(obj)) {
            copy = [];
        } else {
            copy = Object.create(Object.getPrototypeOf(obj));
        }

        // 记录访问过的 obj，以便处理循环引用
        visited.set(obj, copy);

        // 遍历 obj 的属性或数组元素并进行递归深拷贝
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                copy[key] = this.deepCopy(obj[key], visited);
            }
        }

        return copy;
    }

    openCreateRelation = () => {
        const { relation_list, relationMap } = this.state;
        const { onReList } = this.props;
        BsyDialog({
            title: React.language('user.relation.list'),
            height: 513,
            width: 520,
            noFooter: true,
            onContentCreate: (ref) => {
                return <BsyCreateRelationPane
                    relation_list={this.deepCopy(relation_list)}
                    relationMap={this.deepCopy(relationMap)}
                    dialogRef={ref}
                    onSave={(relation_list, relationMap) => {
                        React.axios("/corp/relation/update", { relations: relation_list }).then(res => {
                            this.setState({ relation_list, relationMap }, () => {
                                onReList && onReList()
                            });
                        })
                    }}
                    nodeSort={(attr) => this.setState({ relation_list: attr })}
                />
            }
        })
    }

    selectRelationUser = (item) => {
        return () => {
            let that = this;
            const d = new window.FX.ConfirmDialog({
                title: React.language("member.select.list"),
                height: 586,
                width: 966,
                contentWidget: {
                    rowSize: [451],
                    colSize: [926],
                    padding: 15,
                    items: [[{
                        widgetName: "memberSelect",
                        type: "memberselectpane",

                        editable: !0,
                        hasDock: false,
                        checkEnable: !1,
                        radioItem: !0,
                        radioEnable: !0,
                        checkType: 'radio',
                        memberEnable: !0,
                        noUserMe: that.state._id,
                        departmentEnable: !1,
                        outsiderMemberEnable: !1,
                        outsiderGroupEnable: !1,
                        roleEnable: !1,
                        dynamicEnable: !1,
                        dynamicType: "set",
                        value: !!item.bind_userid ? [item.bind_userid] : null,
                    }]]
                },
                onOk: function () {
                    var dept = d.getWidgetByName("memberSelect");
                    var d1 = dept.getAllJsonValue();
                    if (!d1) {
                        return;
                    }
                    let item1 = window.userSelectMap[d1.users[0]] || {}
                    // for(let i = 0; i < d1.newUser.length; i++){
                    //     if(d1.newUser[i]._id === d1.users[0]){
                    //         item1 = d1.newUser[i];
                    //     }
                    // }
                    const { relations } = that.state;
                    relations.map(res => {
                        if (res._id === item._id) {
                            res.bind_uid = item1.uid;
                            res.bind_userid = item1._id;
                            res.username = item1.nickname;
                        }
                        return null;
                    })
                    that.setState({ relations });
                    return !1;
                }
            });
            d.show()
        }
    }

    addRelation = () => {
        const { relations } = this.state;
        relations.push({
            create_type: "0",
            avatar: "",
            bind_uid: "",
            bind_userid: "",
            r_id: "",
            username: "",
            _id: BsyUtils._genFormEventId(),
        })
        this.setState({ relations });
    }

    removeRelation = (item) => {
        return () => {
            const { relations } = this.state;
            relations.map((res, index) => {
                if (res._id === item._id) {
                    relations.splice(index, 1)
                }
            })
            this.setState({ relations });
        }
    }

    editPane = () => {
        const { nickname, mode, _id, category, join_time, mobileCodeLogin, emailCodeLogin } = this.props;
        const { selectRelationOpen, relation_status, relations, relationMap, main_deptId, remark, title, userUniqueId, sort, memberStatus, memberType, groupname, departments, roles, jobs, job_title, roleSync, phone, email, mobilestatus, emailstatus, country_code } = this.state;
        // const isTripartite = BsyUtils.isQyWinxin() || BsyUtils.isDingding() || BsyUtils.isWeiXin() || BsyUtils.isFeishu() || window.FX.STATIC.user_corps.mode === "fugou";
        const mainDeptsItem = departments ? departments.map(res => {
            return {
                text: res.nickname || res.name,
                value: res.id,
                selected: res.id === main_deptId
            }
        }) : [];

        if (memberType !== 'outsider') {
            return <div className="canEdit">
                <div className="detailCont">
                    {!BsyUtils.isCommon() ? '' : mode !== "resign" && <div className="name line">
                        <div className="detailTitle">
                            <span className="req">
                                *
                            </span>
                            <span>
                                {React.language('name')}
                            </span>
                        </div>
                        <input type="text" onChange={this.nicknameChange} maxLength="64" defaultValue={nickname} />
                    </div>}

                    {!BsyUtils.isCommon() ? '' : mode !== "resign" && <div className="name line">
                        <div className="detailTitle">UserId</div>
                        <input style={{ backgroundColor: '#f5f6f7' }} type="text" readOnly defaultValue={_id} />
                    </div>}

                    {mode !== "resign" && <div className="sort line">
                        <div className="detailTitle">{React.language('trigger.log.failure.index')}</div>
                        <input type="text" onInput={(event) => {
                            event.target.value = event.target.value.replace(/\D/g, '')
                        }} maxLength="5" onChange={this.sortChange} defaultValue={sort} />
                    </div>}
                    {
                        !BsyUtils.isCommon() ? '' : <div className="userUniqueId line">
                            <div className="detailTitle">
                                <span className="req">
                                    *
                                </span>
                                <span>
                                    {React.language('enterprise.user.id')}
                                </span>
                            </div>
                            <input type="text" onChange={this.userUniqueIdChange} defaultValue={userUniqueId} />
                        </div>
                    }

                    {mode !== "resign" && <div className="phone line">
                        <div className="detailTitle">
                            {mobileCodeLogin && <span className="req">
                                *
                            </span>}
                            <span>
                                {React.language('widget.phone')}
                            </span>
                        </div>
                        <LoginAccountInput phoneType={country_code === 86} getValue={this.phoneValue} isreadonly={category !== -1} change={this.changePhone} mobileType={country_code} error={false} maxLength="12" value={phone} mode="mobile" placeholder={React.language('phone.entry.tip')} />
                        {phone && mobilestatus === 0 && <div className="detailStatus">
                            <span className="statusTip">{React.language('msg.target.phone.unverified')}</span>
                            <span className="sendVer" onClick={e => this.verifyEmailMobile("mobile", e)}>{React.language('click.ver')}</span>
                        </div>}
                        {
                            phone && mobilestatus === 1 && category !== -1 && <div className="detailStatus">
                                <span className="statusTip">{React.language('verified.phone.tip')}</span>
                            </div>
                        }
                    </div>}
                    {mode !== "resign" && <div className="email line">
                        <div className="detailTitle">
                            {emailCodeLogin && <span className="req">
                                *
                            </span>}
                            <span>
                                {React.language('email')}
                            </span>
                        </div>
                        <LoginAccountInput blur={this.blurEmail} isreadonly={category !== -1} getValue={this.emailValue} change={this.changeEmail} error={false} maxLength="128" value={email} mode="email" placeholder={React.language('email.entry.tip')} />
                        {email && emailstatus === 0 && <div className="detailStatus">
                            <span className="statusTip">{React.language('msg.target.email.unverified')}</span>
                            <span className="sendVer" onClick={e => this.verifyEmailMobile("email", e)}>{React.language('click.ver')}</span>
                        </div>}
                        {
                            email && emailstatus === 1 && category !== -1 && <div className="detailStatus">
                                <span className="statusTip">{React.language('verified.email.tip')}</span>
                            </div>
                        }
                    </div>}

                    {!BsyUtils.isCommon() ? mode !== "resign" && <div className="name line">
                        <span className="detailTitle ">{React.language('department')}</span>
                        <div className='detailText departmentCont' >
                            {
                                departments.length === 0 ? <div className="select-empty"><span>{React.language('widget.dept.clickToSelect')}</span></div> :
                                    departments.map((item, index) => {
                                        return <div className="item-content department"><i className="icon-department"  ></i><span>{item.nickname || item.name}</span></div>
                                    })
                            }
                        </div>
                    </div> : mode !== "resign" && <div className="name line">
                        <div className="detailTitle">
                            <span className="req">
                                *
                            </span>
                            <span>
                                {React.language('department')}
                            </span>
                        </div>
                        <div className='departmentCont' onClick={this._createChangeDepartmentBubble}>
                            {
                                departments.length === 0 ? <div className="select-empty"><span>{React.language('widget.dept.clickToSelect')}</span></div> :
                                    departments.map(item => {
                                        return <div className="item-content department"><i className="icon-department" /><span>{item.nickname || item.name}</span></div>
                                    })
                            }
                        </div>
                    </div>}
                    {mode !== "resign" && <div className="name line" key={main_deptId}>
                        <div className="detailTitle">
                            <span className="req">
                                *
                            </span>
                            <span>
                                {React.language('main.department')}
                            </span>
                        </div>
                        <BsySelect
                            allowBlank={false}
                            searchable={false}
                            height={34}
                            prohibit={BsyUtils.isQyWinxin() || BsyUtils.isDingding() || BsyUtils.isWeiXin() || BsyUtils.isFeishu()}
                            minWidth={"100%"} onStopEdit={e => {
                                this.setState({
                                    main_deptId: e
                                })
                            }} value={main_deptId} items={mainDeptsItem} />
                        {/* <div className='departmentCont' onClick={this._createChangeMainDepartmentBubble}>
                            {
                                mainDepts.length === 0 ? <div className="select-empty"><span>{React.language('widget.dept.clickToSelect')}</span></div> :
                                    mainDepts.map(item => {
                                        return <div className="item-content department"><i className="icon-department" /><span>{item.nickname || item.name}</span></div>
                                    })
                            }
                        </div> */}
                    </div>}
                    {
                        // roleSync ? '' :
                        mode !== "resign" && <div className="name line">
                            <div className="detailTitle ">{React.language('role')}</div>
                            <div className='departmentCont' onClick={this._createChangeRoleBubble}>
                                {
                                    roles.length === 0 ? <div className="select-empty"><span>{React.language('role.select.tip')}</span></div> :
                                        roles.map(item => {
                                            return <div className="item-content role"><i className="icon-role" /><span>{item.nickname || item.name}</span></div>
                                        })
                                }
                            </div>
                        </div>
                    }


                    {mode !== "resign" &&
                        // (window.FX.Utils.isQyWinxin() || window.FX.Utils.isDingding() || window.FX.Utils.isFeishu()) ? '' :
                        <div className="Title line">
                            <div className="detailTitle">{React.language('subform.data.load.tip21')}</div>

                            <div className="departmentCont" onClick={this._createChangeJobTitleBubble}>

                                {
                                    (!jobs || jobs.length === 0) ? <div className="select-empty"><span>{React.language('job.select.tip')}</span></div> :
                                        jobs.map(item => {
                                            return <div className="item-content jobtitle"> <i className="icon-bsy-jobtitle" /> <span>{`${item.nickname} - ${item.job}`}</span></div>
                                        })
                                }

                            </div>

                        </div>
                    }

                    {mode !== "resign" && relation_status &&
                        // (window.FX.Utils.isQyWinxin() || window.FX.Utils.isDingding() || window.FX.Utils.isFeishu()) ? '' :
                        <div className="relation line">
                            <div className="detailTitle">{React.language('user.relation')}</div>

                            <div className={`relationCont`}>
                                {
                                    relations && relations.map(item => {
                                        let name = item.username;
                                        let avatarurl = item.avatar;
                                        const create_type = item.create_type === "0";
                                        const bg = name ? BsyUtils.formatUserThumb(name.toString()) : '';
                                        return <div className={`relationItem ${create_type ? "" : "noEdit"}`} onMouseEnter={create_type ? () => { } : (event) => {
                                            window.FX.UI.showPopover({
                                                position: "top",
                                                anchor: window.$(event.target),
                                                content: window.$("<span/>").text(React.language('relation.tip1')),
                                                type: "dark"
                                            })
                                        }} onMouseLeave={create_type ? () => { } : () => {
                                            window.FX.UI.closePopover()
                                        }} >
                                            <div className="selectRelation" title={relationMap[item.r_id] ? relationMap[item.r_id].name : ""} onClick={create_type ? this.switchRelation(item) : () => { }}>
                                                <span>{relationMap[item.r_id] ? relationMap[item.r_id].name : ""}</span>
                                                <i className={`icon-bsy-xia`}></i>
                                            </div>
                                            <div className="addRelationUser" title={name} onClick={create_type ? this.selectRelationUser(item) : () => { }}>
                                                {
                                                    !!item.bind_uid ? <div className="item-content department"><div className="avatar">
                                                        {!!avatarurl ? <img src={avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                                                    </div><span>{name}</span></div> : <span className='empty-msg'>{React.language('add.user.relation')}</span>
                                                }
                                            </div>
                                            {create_type && <div className="removeRelationUser">
                                                <i className='icon-remove' onClick={this.removeRelation(item)}></i>
                                            </div>}
                                        </div>
                                    })
                                }
                            </div>
                            <div className="addRelation" onClick={this.addRelation}>
                                <i className='icon-bsy-add'></i>
                                <span>{React.language('add.relation.user')}</span>
                            </div>
                        </div>
                    }

                    {mode !== "resign" && <div className="remark line">
                        <div className="detailTitle">{React.language('contact.note.title')}</div>
                        <input type="text" onChange={this.remarkChange} maxLength="64" defaultValue={remark} />
                    </div>}

                    {mode !== "resign" && join_time && <div className="remark line">
                        <div className="detailTitle">{React.language('join.time')}</div>
                        <span className="detailText">{join_time}</span>
                    </div>}
                </div>
            </div>
        } else {
            if (memberStatus === 'deleted') {
                return <div className="canEdit">
                    <div className="detailCont">
                        <div className="userUniqueId line">
                            <div className="detailTitle">{React.language('enterprise.user.id')}</div>
                            <input type="text" onChange={this.userUniqueIdChange} defaultValue={userUniqueId} />
                        </div>
                    </div>
                </div>
            } else {
                return <div className="canEdit">
                    <div className="detailCont">
                        <div className="name line">
                            <div className="detailTitle">{React.language('name')}</div>
                            <input type="text" maxLength={64} onChange={this.nicknameChange} defaultValue={nickname} />
                        </div>
                        <div className="uid line">
                            <span className="detailTitle">{"UserId"}</span>
                            <input type="text" className="isreadonly" style={{ backgroundColor: "#f5f6f7", boxShadow: "inset 0 0 0 1000px #f5f6f7" }} defaultValue={_id} readOnly={true} />
                        </div>
                        <div className="sort line">
                            <div className="detailTitle">{React.language('trigger.log.failure.index')}</div>
                            <input type="text" onInput={(event) => {
                                event.target.value = event.target.value.replace(/\D/g, '')
                            }} maxLength="5" onChange={this.sortChange} defaultValue={sort} />
                        </div>
                        <div className="userUniqueId line">
                            <div className="detailTitle">{React.language('enterprise.user.id')}</div>
                            <input type="text" onChange={this.userUniqueIdChange} defaultValue={userUniqueId} />
                        </div>
                        {mode !== "resign" && <div className="phone line">
                            <div className="detailTitle">
                                {mobileCodeLogin && <span className="req">
                                    *
                                </span>}
                                <span>
                                    {React.language('widget.phone')}
                                </span>
                            </div>
                            <LoginAccountInput phoneType={country_code === 86} getValue={this.phoneValue} isreadonly={category !== -1} change={this.changePhone} mobileType={country_code} error={false} maxLength="12" value={phone} mode="mobile" placeholder={React.language('phone.entry.tip')} />
                            {phone && mobilestatus === 0 && <div className="detailStatus">
                                <span className="statusTip">{React.language('msg.target.phone.unverified')}</span>
                                <span className="sendVer" onClick={e => this.verifyEmailMobile("mobile", e)}>{React.language('click.ver')}</span>
                            </div>}
                            {
                                phone && mobilestatus === 1 && category !== -1 && <div className="detailStatus">
                                    <span className="statusTip">{React.language('verified.phone.tip')}</span>
                                </div>
                            }
                        </div>}
                        {mode !== "resign" && <div className="email line">
                            <div className="detailTitle">
                                {emailCodeLogin && <span className="req">
                                    *
                                </span>}
                                <span>
                                    {React.language('email')}
                                </span>
                            </div>
                            <LoginAccountInput blur={this.blurEmail} isreadonly={category !== -1} getValue={this.emailValue} change={this.changeEmail} error={false} maxLength="128" value={email} mode="email" placeholder={React.language('email.entry.tip')} />
                            {email && emailstatus === 0 && <div className="detailStatus">
                                <span className="statusTip">{React.language('msg.target.email.unverified')}</span>
                                <span className="sendVer" onClick={e => this.verifyEmailMobile("email", e)}>{React.language('click.ver')}</span>
                            </div>}
                            {
                                email && emailstatus === 1 && category !== -1 && <div className="detailStatus">
                                    <span className="statusTip">{React.language('verified.email.tip')}</span>
                                </div>
                            }
                        </div>}

                        <div className="group line">
                            <div className="detailTitle">{React.language('outsider.member.in.group')}</div>
                            <div className='select-outsider-group departmentCont' onClick={e => { this._createChangOutsiderBubble(memberStatus) }} >
                                <div className={'item-content'}>
                                    <i className='icon-outsdier-defaut-group'></i>
                                    <span > {groupname} </span>
                                </div>
                            </div>
                        </div>

                        <div className="remark line">
                            <div className="detailTitle">{React.language('contact.note.title')}</div>
                            <input type="text" maxLength="64" onChange={this.remarkChange} defaultValue={remark} />
                        </div>
                    </div>
                </div>
            }
        }
    }

    render() {
        const { avatarurl, nickname, category, width, frozen } = this.props;
        const { username, memberType, memberRemove } = this.state;
        const bg = nickname ? BsyUtils.formatUserThumb(nickname.toString()) : '';
        return (
            <div className={"content " + window.mode} style={{ width: width }}>
                <div className="alertHeader">
                    <div className="avatar">
                        {avatarurl ? <img src={avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                    </div>
                    <div className="headerDetail">
                        <div className="name">
                            <span className="tName" title={nickname}>{nickname}</span>
                            {category === 0 && <span className="category">{React.language('manager.creator')}</span>}
                            {(!memberType || memberType === "outsider") && <span
                                className={frozen === 0 ? "frozen" : "frozen not"}>{frozen === 0 ? React.language('activated') : React.language('deactivated')}</span>}
                        </div>
                        <div className="account">
                            <span className="detailTitle">{React.language('receipt.account') + "："}</span>
                            <span className="detailText">{username}</span>
                        </div>
                    </div>
                    <div className="alertClose">
                        <i onClick={this.cancelClick} className="icon-close-large" />
                    </div>
                </div>
                <div className="editContent">
                    {/* {memberType === 'outsider' && this.onlyReadPane()} */}
                    {this.editPane()}
                </div>
                <div className="alertFooter">
                    {
                        <BsyIconBtn
                            text={React.language('save')}
                            click={this.onSave}
                            iconName=""
                            type="blue"
                            mode={window.mode}
                        />
                    }

                    {category === 2 && memberType !== 'outsider' && window.FX.STATIC.user_corps.mode === "common" && memberRemove && <BsyIconBtn
                        text={React.language('switch.to.resignation')}
                        click={this.dismissionClick}
                        type="border-red"
                        mode={window.mode}
                    />}
                </div>
            </div>
        )
    }
}

export default AlertList